import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import {
  userIsAdmin,
  userIsManager,
  userCanSeeLikes,
} from '../../helpers/Auth';
import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalAllowFavoriting = (({
  allowFavoriting,
  handleChangeAllowFavoriting,
  handleClose,
}) => {
  const intl = useIntl();

  const disabled = !canUserManageShare() || !userCanSeeLikes();

  return (
    <div
      className="share-allow-favoriting share-setting"
    >
      <Label for="inpAllowFavoriting" className={classnames('switch', { disabled })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Allow favoriting' })}
          <HelpIcon id="share-allow-favoriting">
            {intl.formatMessage({ defaultMessage: 'Allow recipients to favorite files and Collections.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-allow-favoriting" simple={true} />
          {userHasFeature('share-allow-favoriting') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="allow-favoriting"
                id="inpAllowFavoriting"
                value={true}
                checked={allowFavoriting}
                disabled={disabled}
                onChange={handleChangeAllowFavoriting}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
      {((userIsAdmin() || userIsManager()) && !userCanSeeLikes()) && (
        <div className="restricted-notice">
          {intl.formatMessage({ defaultMessage: 'Enable comments in your <link>workspace settings</link>' }, {
            link: (msg) => (
              <Link to="/admin/workspace?tab=general" onClick={handleClose}>
                {msg}
              </Link>
            ),
          })}
        </div>
      )}
    </div>
  );
});

ShareModalAllowFavoriting.propTypes = {
  allowFavoriting: PropTypes.bool.isRequired,
  handleChangeAllowFavoriting: PropTypes.func.isRequired,
  handleClose: PropTypes.func,
};

ShareModalAllowFavoriting.defaultProps = {
  handleClose: () => {},
};

export default ShareModalAllowFavoriting;
